import React from "react";
import CaseStudyPage from "../../components/CaseStudyPage";
import { caseStudies } from "../../data/projects";

export default function CampusPost() {
  const project = caseStudies.find((p) => p.slug === "campuspost");
  const currentIndex = caseStudies.findIndex((p) => p.slug === "campuspost");
  const nextProject = caseStudies[(currentIndex + 1) % caseStudies.length];

  return <CaseStudyPage project={project} nextProject={nextProject} />;
}
